module.exports = __webpack_public_path__ + "img/animate.2de00bf5.png";